import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledSignalText = styled.div`
    ${mixins.setFontVariant("input2", colorsPalettes.carbon[250])};

    &:first-letter {
        text-transform: capitalize;
    }
`;

export const StyledSignalCompanyLink = styled.a`
    color: ${colorsPalettes.carbon[250]};
    text-decoration: underline;

    &:hover {
        color: ${colorsPalettes.carbon[400]};
    }
`;
